var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    staticClass: "news-form"
  }, [_c("a-form", {
    attrs: {
      form: _vm.form
    }
  }, [_c("a-alert", {
    attrs: {
      message: _vm.$t("form.newTip"),
      "show-icon": ""
    }
  }), _c("Card", {
    attrs: {
      title: _vm.$t("form.setting")
    }
  }, [_c("CardItem", {
    attrs: {
      title: _vm.$t("form.location"),
      layout: "vertical"
    }
  }, [_c("a-select", {
    attrs: {
      mode: "multiple",
      placeholder: _vm.$t("form.placeSelectLocation")
    },
    model: {
      value: _vm.value.location,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "location", $$v);
      },
      expression: "value.location"
    }
  }, _vm._l(_vm.locationClient, function (item, i) {
    return _c("a-select-option", {
      key: i,
      attrs: {
        value: item.value
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), 1)], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.bgColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.bgColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "bgColor", $$v);
      },
      expression: "value.bgColor"
    }
  })], 1)], 1), _c("Card", {
    attrs: {
      title: _vm.$t("form.newTitle")
    }
  }, [_c("Title", {
    attrs: {
      type: "input"
    },
    model: {
      value: _vm.value.newsTitle,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "newsTitle", $$v);
      },
      expression: "value.newsTitle"
    }
  }), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.titleColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.newsTitleColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "newsTitleColor", $$v);
      },
      expression: "value.newsTitleColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textSize"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 12,
      max: 80,
      suffix: "px"
    },
    model: {
      value: _vm.value.newsTitleFontSize,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "newsTitleFontSize", $$v);
      },
      expression: "value.newsTitleFontSize"
    }
  })], 1)], 1), _c("Card", {
    attrs: {
      title: _vm.$t("form.moreText")
    }
  }, [_c("CardItem", {
    attrs: {
      title: _vm.$t("form.moreVisible")
    }
  }, [_c("a-switch", {
    attrs: {
      "checked-children": _vm.$t("form.visible"),
      "un-checked-children": _vm.$t("form.hidden")
    },
    model: {
      value: _vm.value.newsMoreVisible,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "newsMoreVisible", $$v);
      },
      expression: "value.newsMoreVisible"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: "",
      layout: "vertical"
    }
  }, [_c("Title", {
    staticClass: "newMoreTitle",
    attrs: {
      type: "input"
    },
    model: {
      value: _vm.value.moreText,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "moreText", $$v);
      },
      expression: "value.moreText"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.titleColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.moreTextColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "moreTextColor", $$v);
      },
      expression: "value.moreTextColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textSize"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 12,
      max: 80,
      suffix: "px"
    },
    model: {
      value: _vm.value.moreTextSize,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "moreTextSize", $$v);
      },
      expression: "value.moreTextSize"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.moreLink"),
      layout: "vertical"
    }
  }, [_c("a-textarea", {
    attrs: {
      rows: 5
    },
    model: {
      value: _vm.value.moreLink,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "moreLink", $$v);
      },
      expression: "value.moreLink"
    }
  })], 1)], 1), _c("Card", {
    attrs: {
      title: _vm.$t("form.newList")
    }
  }, [_c("CardItem", {
    attrs: {
      title: _vm.$t("form.showPublicDate")
    }
  }, [_c("a-switch", {
    attrs: {
      "checked-children": _vm.$t("form.visible"),
      "un-checked-children": _vm.$t("form.hidden")
    },
    model: {
      value: _vm.value.showdate,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "showdate", $$v);
      },
      expression: "value.showdate"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.newsListTitleColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "newsListTitleColor", $$v);
      },
      expression: "value.newsListTitleColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textOrIconHoverColor2"),
      tip: _vm.$t("form.onlyPc")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.newsListHoverTitleColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "newsListHoverTitleColor", $$v);
      },
      expression: "value.newsListHoverTitleColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.mobileBg")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.newsListMobileBg,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "newsListMobileBg", $$v);
      },
      expression: "value.newsListMobileBg"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.pcBg")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.newsListPCBg,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "newsListPCBg", $$v);
      },
      expression: "value.newsListPCBg"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textSize"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 12,
      max: 80,
      suffix: "px"
    },
    model: {
      value: _vm.value.newsListTitleFontSize,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "newsListTitleFontSize", $$v);
      },
      expression: "value.newsListTitleFontSize"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.mobileShowNum"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 1,
      max: 9
    },
    model: {
      value: _vm.value.mobileShowNum,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "mobileShowNum", $$v);
      },
      expression: "value.mobileShowNum"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.pcShowNum"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 1,
      max: 9
    },
    model: {
      value: _vm.value.pcShowNum,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pcShowNum", $$v);
      },
      expression: "value.pcShowNum"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };